var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFraktklass100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 100
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M3.818 22.212h.879c0-.005 1.182-2.592 2.777-2.592s2.731 2.592 2.731 2.592h10.462V7.631h-20v14.581Z",
    fill: "#aee9ff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M7.414 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M24.69 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M20.7 22.948a.664.664 0 0 1-.664-.664V8.462a.4.4 0 0 0-.337-.133H1.666a.4.4 0 0 0-.338.138v13.019a.4.4 0 0 0 .337.133h2.981a.665.665 0 0 1 0 1.329h-2.98A1.576 1.576 0 0 1 0 21.486V8.462A1.576 1.576 0 0 1 1.666 7H19.7a1.576 1.576 0 0 1 1.666 1.462v13.821a.664.664 0 0 1-.666.665"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M20.703 22.948H10.072a.665.665 0 1 1 0-1.329h10.631a.665.665 0 0 1 0 1.329"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M30.539 22.948h-2.526a.665.665 0 0 1 0-1.329h2.526a.133.133 0 0 0 .132-.132v-3.686a.1.1 0 0 0-.012-.054l-2.378-5.352a.13.13 0 0 0-.121-.079h-7.457a.665.665 0 1 1 0-1.329h7.456a1.46 1.46 0 0 1 1.336.868l2.379 5.352a1.45 1.45 0 0 1 .126.594v3.686a1.464 1.464 0 0 1-1.461 1.461"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M22.032 22.948h-1.329a.665.665 0 0 1 0-1.329h1.329a.665.665 0 1 1 0 1.329"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M4.451 11.291v.378c0 .522-.264.726-.781.726h-.907v1.115h1.688v4.912h1.424v-7.131Zm5.98 7.231c2.215 0 2.563-2.086 2.563-3.682 0-1.565-.348-3.671-2.605-3.671-2.352-.001-2.574 2.218-2.574 3.66 0 1.473.243 3.693 2.616 3.693m-.024-1.33c-1.052 0-1.126-1.176-1.126-2.332 0-1.207.074-2.362 1.107-2.362s1.119 1.145 1.119 2.352c0 1.155-.074 2.342-1.1 2.342m5.741 1.33c2.215 0 2.559-2.087 2.559-3.683 0-1.565-.348-3.671-2.605-3.671-2.352 0-2.574 2.219-2.574 3.661.004 1.473.247 3.693 2.62 3.693m-.021-1.33c-1.055 0-1.129-1.176-1.129-2.332 0-1.207.074-2.362 1.107-2.362s1.118 1.145 1.118 2.352c.001 1.155-.073 2.342-1.096 2.342"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraktklass100);
export default __webpack_public_path__ + "static/media/fraktklass-100.eab6b0e5d46fa6a7d646b90b2fadae99.svg";
export { ForwardRef as ReactComponent };